<template>
    <div>
        <v-form  ref="queryForm">
            <v-row justify="center">
                <v-col cols="2">
                    <v-text-field label="部门关键字" prepend-inner-icon="search"
                                  :disabled="batchAddFlag"
                                  v-model="queryRequest.deptName" clearable></v-text-field>
                </v-col>
                <v-col cols="3" align="left">
                    <v-btn color="primary"
                           :disabled="batchAddFlag"
                           @click='query'>搜索</v-btn>
                    <v-btn
                            :disabled="batchAddFlag"
                            color="primary"
                            class="ma-2"
                            @click="resetQuery"
                    >
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <v-row justify="center">
            <v-col
                    cols="11">
                <v-card>

                    <v-data-table
                            :single-select="false"
                            show-select
                            v-model="selectDept"
                            :headers="deptHeaders"
                            :server-items-length="total"
                            :items="tableData"
                            :options.sync="tableOptions"
                            :page.sync="queryRequest.pagedQueryInfo.index">

                        <template v-slot:top>

                            <div class="pa-4 d-flex justify-space-between">
                                <h2>部门信息</h2>

                                <div class="d-flex">
                                    <!--<v-switch v-model="batchAddFlag" class="ma-2" label=""></v-switch>-->
                                    <v-btn
                                            color="primary"
                                            class="ma-2"
                                            :loading="loading"
                                            @click="batchOpen">
                                        批量开通({{selectDept.length}})
                                    </v-btn>
                                </div>

                            </div>
                        </template>

                        <template v-slot:header.data-table-select>
                            <div></div>
                        </template>

                        <template v-slot:item.data-table-select="{item, isSelected, select}">
                            <v-simple-checkbox
                                    :ripple="false"
                                    v-if="item.selected"
                                    :value="item.selected">
                            </v-simple-checkbox>
                            <v-simple-checkbox
                                    v-else
                                    :ripple="false"
                                    color="primary"
                                    :value="isSelected"
                                    @input="select($event)">
                            </v-simple-checkbox>
                        </template>

                    </v-data-table>

                </v-card>
            </v-col>
        </v-row>

        <!--<v-simple-checkbox></v-simple-checkbox>-->

        <z-notify ref="notify"></z-notify>
    </div>
</template>

<script>
  import {deptPageQuery, batchOpen} from '@/api/dept'

  export default {
    name: "OpenDepartment",
    data() {
      return {
        batchAddFlag:false,
        total: 0,
        loading: false,
        eqpSearch: '',
        //查询机构下部门的请求
        queryRequest: {
          deptName: '',
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          }
        },
        deptInfo: {
          id: '',
          deptName: '',
        },
        //批量开通请求
        batchOpenRequset: {
          deptInfoList: [{
            deptId: '',
            deptName: '',
          }],
          institutionId: '',
          institutionName: ''
        },
        deptHeaders: [
          {
            text: '部门',
            align: 'start',
            sortable: false,
            value: 'deptName'
          }
        ],
        selectDept: [],
        tableOptions: {},
        tableData: [],
      }
    },
    watch: {
      tableOptions: {
        handler(val) {
          console.log(val, '分页查询');
          if (val.itemsPerPage == -1) {
            this.queryRequest.pagedQueryInfo.index = 1
            this.queryRequest.pagedQueryInfo.pageSize = 999999
          } else {
            this.queryRequest.pagedQueryInfo.index = val.page
            this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
          }
          this.handleQuery()
        }
      },
      selectDept(newValue, oldValue) {
        // alert(newValue.length);
      }
    },
    methods: {
      query(){
        this.queryRequest.pagedQueryInfo.index = 1;
        this.handleQuery();
      },
      //根据机构编号查询部门
      handleQuery() {
        this.loading = true;
        deptPageQuery(this.queryRequest).then(res => {
          this.tableData = res.list;
          this.total = res.total;
          this.loading = false;

          // this.selectDept = [];
          // for (var i = 0; i < this.tableData.length; i++) {
          //   if (this.tableData[i].selected) {
          //     this.selectDept.push(this.tableData[i]);
          //   }
          // }

        }).catch(err => {
          this.loading = false;
        })
      },
      //批量开通
      batchOpen() {
        if(this.selectDept.length == 0){
            this.$refs.notify.show("请勾选要开通的部门", {timeout: 1000, color: "red"})
            return ;
        }
        let res = this.selectDept.map(({id, deptName}) => ({id, deptName}))
        this.batchOpenRequset.deptInfoList = res;
        this.batchOpenRequset.institutionId = this.queryRequest.hospId
        batchOpen(this.batchOpenRequset).then(res => {
          this.$refs.notify.show("开通成功", {timeout: 1000, color: "green"})
          this.selectDept = [];
          this.handleQuery();
        }).catch(err => {
          this.loading = false
        })
      },
      //刷新
      resetQuery() {
        Object.assign(this.$data.queryRequest, this.$options.data().queryRequest)
        // this.tableData = []
      }
    },
    mounted() {

    },
    created() {

    }
  }
</script>

<style scoped>

</style>